<template>
  <div class="zlItCourseEdit">
    <!-- 左侧章节树 -->
    <div class="zlItCourseEdit_tree">
      <div class="goback" @click="goback">
        <i class="el-icon-arrow-left"></i>返回
      </div>
      <div class="zlItCourseEdit_name">{{courseName}}</div>
      <zl-sidebar
        ref="zlSidebar"
        @setStatus="setStatus"
        :courseId="courseId"
        :subjectId="subjectId"
        @openAddResoures="openAddResoures"
        @handleTreeNodeClick="handleTreeNodeClick"
      ></zl-sidebar>
    </div>
    <div class="zlItCourseEdit_content" v-loading="zl_loading">
      <!-- 内容展示 -->
      <transition name="el-zoom-in-center">
        <div class="zlItCourseEdit_show_status_1" v-if="status === 1">
          <div class="chapterHead">
            <span class="chapterName">
              <span class="kk">
                 <img
                   v-if="this.addType"
                   :src="'../../static/images/newCourseImages/'+ courseIcon[this.addType].image"
                   :alt="courseIcon[this.addType].alt"
                 />
              </span>
              {{ catalogue.catalogName}}
            </span>
            <span>
              <el-button size="small" type="primary" @click="editor">编辑</el-button>
              <!--              <el-button size="small" type="primary" @click="remove">删除</el-button>-->
            </span>
          </div>
          <status_1_content v-model="chapter"></status_1_content>
        </div>
      </transition>
      <!-- 内容编辑 -->
      <transition name="el-zoom-in-center">
        <div class="zlItCourseEdit_editor_status_2" v-if="status === 2">
          <div class="chapterHead">
            <span class="chapterName">
              <span class="kk">
                 <img
                   :src="'../../static/images/newCourseImages/'+ courseIcon[this.addType].image"
                   :alt="courseIcon[this.addType].alt"
                 />
              </span>

                <el-input v-if="!isEditor"
                  style="width: 200px"
                  v-model="sectionName"
                  size="small"
                  placeholder="请输入名称"
                ></el-input>
              <span v-else> {{ catalogue.catalogName}}</span>
            </span>
            <span>
              <el-button size="small" type="primary" @click="addCatalogAndResourse">保存</el-button>
              <el-button size="small" type="primary" @click="clear">清空</el-button>
              <el-button size="small" type="primary" @click="cancel">取消</el-button>
            </span>
          </div>
          <div class="zlItCourseEdit_editor">
            <!--  addType // 1素材，2作业，3习题，5测验，6图文，7图片，8文档, 9音频，10视频 -->
            <transition name="el-zoom-in-center" v-if="addType == 7 || addType == 8 || addType == 10">
              <add-resourse v-model="selectResourse" :subjectId="subjectId" :type="addType"></add-resourse>
            </transition>
            <transition name="el-zoom-in-center" v-else-if="addType == 6">
              <add-mixed-mode v-model="questionConfigure" :subjectId="subjectId"></add-mixed-mode>
            </transition>
          </div>
        </div>
      </transition>
      <!-- 首次进来展示内容 -->
      <transition name="el-zoom-in-center">
        <div class="zlItCourseEdit_status_3" v-if="status === 3">
          <div class="zlItCourseEdit_status_3_c">
            <p>在左侧创建目录，寻找加号，</p>
            <p>创建目录时选择课程类型，</p>
            <p>此处为课程展示和编辑区域，</p>
            <p>如有问题，请联系管理人员。</p>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  /**
   *  create by wjl at 2021.6.5
   *   新课程模块   *   （ 单资源课程 ）
   */
import zlSidebar from "../component/zl-sidebar"; // 目录树
import addResourse from "../component/addResourse"; //  添加素材，图片或视频
import addMixedMode from "./components/addMixedMode"; // 添加图文
import status_1_content from "../component/zlItCourseEdit_show_status_1_content"; // 内容展示
import * as api from "../../api/courseApi";
import * as sourceApi from '../../api/sourceApi'
import ipynb from '@/components/js/ipynb.js'
export default {
  name: "zlItCourseEdit",
  components: {
    zlSidebar,
    addResourse,
    addMixedMode,
    status_1_content,
  },
  data() {
    return {
      courseId: this.$route.query.courseId,
      subjectId: this.$route.query.subjectId,
      courseName: this.$route.query.courseName,
      subjectName: this.$route.query.subjectName,
      type: this.$route.query.type,  //课程类型 ，2单项 3综合
      zl_loading:false,
      questionConfigure: [],
      catalogue: {}, //所选，目录
      chapter: {}, // 所选章节或课程
      courseIcon: {
        1: {
          image: "tp-2@2x.png",
          alt: "图片",
        },
        2: {
          image: "wd-2@2x.png",
          alt: "文档",
        },
        3: {
          image: "sc-2@2x.png",
          alt: "实操题",
        },
        4: {
          image: "sp-2@2x.png",
          alt: "视频",
        },
        5: {
          image: "ceyan-2@2x.png",
          alt: "测验",
        },
        6: {
          image: "zh-2@2x.png",
          alt: "图文",
        },
        7: {
          image: "tp-2@2x.png",
          alt: "图片",
        },
        8: {
          image: "wd-2@2x.png",
          alt: "文档",
        },
        9: {
          image: "yp-2@2x.png",
          alt: "音频",
        },
        10: {
          image: "sp-2@2x.png",
          alt: "视频",
        },
      },
      status: 3, //  编辑页的状态，1展示内容，2编辑内容
      addType: 0, // 1素材，2作业，3习题，5测验，6图文，7图片，8文档, 9音频，10视频

      // 2021.7.9
      sectionName: "", // 新增素材目录是的名称
      selectResourse: 0, // 选中的素材id

      // 2021.7.12
      isEditor: false,
      ipynb: ipynb,
      cellsCode: {
        "cell_type": "code",
        "execution_count": null,
        "metadata": {
          "collapsed": true
        },
        "outputs": [],
        "source": []
      },
      ipynbFileId:null,
    };
  },
  created() {
    let subjectId = sessionStorage.getItem('subjectId');
    if (subjectId != this.subjectId){
      sessionStorage.setItem('subjectId', this.subjectId);
      this.getTreeList();
    }else{
      let knowledgePoints = sessionStorage.getItem('knowledgePoints');
      if (!knowledgePoints) this.getTreeList();
    }
  },
  methods: {
    getTreeList(){
      sessionStorage.setItem('knowledgePoints', '');
      sourceApi.getMaterialTreeListById(this.subjectId).then(res =>{
        if(res.code =="0"){
          sessionStorage.setItem('knowledgePoints', JSON.stringify(res.data.materials));
        }
      })
    },
    handleTreeNodeClick(treeData) {
      // if (treeData.catalogParentId == 0) return;
      if (
        !treeData.children ||
        (treeData.children && !treeData.children.length)
      ) {
        this.zl_loading = true;
        this.catalogue = treeData;
        this.isEditor = false;
        this.chapter = {};
        api
          .handleNodeClick(this.courseId, treeData.id)
          .then((res) => {
            if (res.code == 0) {
              if (res.data && res.data.length) {
                this.chapter = res.data[0];
                console.log('--1--', this.chapter)
                if (this.chapter.type === 6){
                  let imageText = JSON.parse(this.chapter.imageText);
                  let bool = imageText.filter(item =>{
                    return item.extendOption.allCode
                  });
                  if(bool.length){
                    this.getCodersLog();
                  }
                }
                this.addType = this.chapter.type;
                this.status = 1; // 展示页面
              } else {
                this.sectionName = "";
                this.status = 3; // 编辑
              }
            } else {
              this.$message.warning("暂无数据");
            }
          })
          .finally(() => {
            this.zl_loading = false;
          })
          .catch((error) => {
            this.$messageError(error);
          });
      }
    },
    setStatus(n) {
      // 初始化
      this.isEditor = false;
      this.status = n;
      this.catalogue = {};
      this.chapter = {};
      this.questionConfigure = [];
      this.sectionName = "";
      this.selectResourse = "";
      this.addType = 0;
    },
    openAddResoures(chapter, catalogue, from) {
      if (from === "add") {
        this.setStatus(2)
      } else {
        this.sectionName = catalogue.catalogName;
        this.status = 2;
      }
      this.addType = chapter.type;
      if (this.addType == 6 && chapter.imageText) {
        this.questionConfigure = chapter.imageText;
      }
      this.catalogue = catalogue;
    },

    addCatalogAndResourse() {
      if (!this.isEditor && !this.sectionName) {
        return this.$message.warning("请输入页面名称");
      }
      if (this.addType == 6) {
        if (this.questionConfigure.length) {
          this.selectResourse = JSON.stringify(this.questionConfigure);
        } else {
          return this.$message.warning("请选择素材");
        }
      } else if (!this.selectResourse) {
        return this.$message.warning("请选择素材");
      }

      if (this.isEditor) {
        let data = {
          type: this.addType,
          resourceId: this.selectResourse,
          courseId: this.courseId,
        };

        if (data.type == 6){
          let imageText = JSON.parse(data.resourceId);
          let cells = this.ipynb.cells;
          cells[0].source = [
            '## '+ this.catalogue.catalogName
          ]
          let bool = imageText.filter(item =>{
            return item.extendOption.allCode
          });
          if(bool.length){
            [].forEach.call(imageText, item =>{
              if (item.type == 11){
                let cellsCode = JSON.parse(JSON.stringify(this.cellsCode));
                if (item.value){
                  let code = item.value;
                  cellsCode.source = code.split('\n').map(c => c + '\n')
                }
                cells.push(cellsCode);
              }
            })
          }
          this.postRunCoders(this.ipynb);
          this.$refs.zlSidebar.addImageText(this.catalogue, data);
        }else if (data.type){
          this.$refs.zlSidebar.addResourse(this.catalogue, data);
        }

      } else {
        let data = {
          id: "",
          catalogName: this.sectionName,
          catalogParentId: this.catalogue.id,
          courseId: this.courseId,
          resourceId: this.selectResourse,
          isEditor: this.isEditor,
          type: this.addType,
        };
          this.$refs.zlSidebar.blurEdit(data);
      }
    },

    getCodersLog(){
      let param = {
        "targetId": this.catalogue.id,
        "targetType":1,
      }
      api.getCodersLog(param).then(res =>{
        if (res.code == 0){
          if (res.data.length){
            this.ipynbFileId = res.data[0].id;
          }
        }
      })
    },
    postRunCoders(ipynb){
      let param = {
        "targetId": this.catalogue.id,
        "targetType":1,
        "dataType":1,
        "contentType":1,
        "content": JSON.stringify(ipynb),
        "fileName": this.catalogue.catalogName,
        "id": this.ipynbFileId,
      }
      api.postRunCoders(param).then(() =>{})
    },
    editor() {
      this.isEditor = true;
      this.openAddResoures(this.chapter, this.catalogue);
    },
    // 删除目录和目录下的资源
    remove() {
      this.$refs.zlSidebar.remove({}, this.catalogue, this.chapter);
    },
    clear(){
      this.questionConfigure = [];
    },
    cancel() {
      if (this.isEditor) {
        this.handleTreeNodeClick(this.catalogue);
      } else {
        this.status = 3;
      }
    },
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="scss">
.zlItCourseEdit {
  width: 100%;
  height: 100%;
  min-width: 900px;
  overflow: hidden;
  font-size: 13px;
  user-select: none;
  display: flex;
  .zlItCourseEdit_tree {
    width: 320px;
    background: #f6f6f6;
    .goback {
      line-height: 30px;
      cursor: pointer;
      .el-icon-arrow-left {
        font-size: 14px;
        padding-left: 15px;
        padding-right: 6px;
        color: #2b2a33;
        line-height: 20px;
        font-weight: 600;
      }
    }

    .zlItCourseEdit_name {
      font-size: 22px;
      font-weight: 600;
      text-align: center;
      padding: 20% 0;
    }
  }
  .chapterHead {
    display: flex;
    justify-content: space-between;
    line-height: 100px;
    height: 100px;
    .chapterName {
      font-size: 22px;
      font-weight: 600;
      display: inline-flex;
      .kk{
        width: 100px;
        text-align: center;
        line-height: 100px;
        background: #EDEDED;
        margin-right: 20px;
        border-radius: 5px;
        img {
          height: 56px;
          margin-top: 21px;
        }
      }
    }
  }
  .zlItCourseEdit_content {
    flex: 1;
    padding: 1% 3%;
  }
  /* 当状态为3，初始页面 */
  .zlItCourseEdit_status_3 {
    width: 100%;
    height: 100%;
    position: relative;
    .zlItCourseEdit_status_3_c {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      p {
        padding: 6px 0;
        font-size: 15px;
        color: #999999;
      }
    }
  }
  /* 有数据时，展示内容 */
  .zlItCourseEdit_show_status_1 {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .zlItCourseEdit_show_status_1_content {
      flex: 1;
      background: #0e9aff;
    }
  }
  /* 编辑内容 */
  .zlItCourseEdit_editor_status_2 {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    .zlItCourseEdit_editor {
      flex: 1;
      overflow: hidden;
    }
  }
  .el-button {
    background: #2b2a33;
    border-color: #2b2a33;
  }
  /deep/ .cell {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/single_resource_course/zlItCourseEdit.vue